/**
 * NetFUNNEL Global Initializer
 * - AS-IS script 태그 그대로 JS화
 * - SPA 최초 진입 시 1회 실행
 */

export function initNetFunnel() {
    if (window.__NETFUNNEL_INITED__) return;
    window.__NETFUNNEL_INITED__ = true;

    const normalizeEnvUrl = (value) => {
        if (!value) return value;
        return String(value)
            .trim()
            .replace(/^["';\s]+|["';\s]+$/g, '');
    };

    // ===== AS-IS 기준 설정 =====
    const NF_AGENT_URL = normalizeEnvUrl(import.meta.env.VITE_NF_AGENT_URL);
    const EUM_AGENT_URL = normalizeEnvUrl(import.meta.env.VITE_EUM_AGENT_URL);
    const NF_SERVER_URL = normalizeEnvUrl(import.meta.env.VITE_NF_SERVER_URL);
    const NF_SETTING_URL = normalizeEnvUrl(import.meta.env.VITE_NF_SETTING_URL);
    const NF_VWR_PAGE_URL = normalizeEnvUrl(import.meta.env.VITE_NF_VWR_PAGE_URL);
    const CLIENT_ID = normalizeEnvUrl(import.meta.env.VITE_NF_CLIENT_ID);
    
    // ==========================

    /* ==========================
     * NetFUNNEL Agent
     * ========================== */
    if (!NF_AGENT_URL) {
        console.warn('[NetFUNNEL] NF agent url is empty');
        return;
    }

    const nfScript = document.createElement('script');
    nfScript.src = NF_AGENT_URL;

    nfScript.dataset.nfServerUrl = NF_SERVER_URL;
    nfScript.dataset.nfSettingUrl = NF_SETTING_URL;
    nfScript.dataset.nfVwrPageUrl = NF_VWR_PAGE_URL;

    nfScript.dataset.nfRetryCount = '1';
    nfScript.dataset.nfNetworkTimeout = '1000';
    nfScript.dataset.nfPrintLog = 'false';
    nfScript.dataset.nfUseCredential = 'false';
    nfScript.dataset.nfErrorBypass = 'true';

    nfScript.onerror = () => {
        console.error('[NetFUNNEL] agent load failed');
    };

    document.head.appendChild(nfScript);

    /* ==========================
     * EUM Agent (AS-IS 동일)
     * ========================== */
    if (!EUM_AGENT_URL) {
        console.warn('[NetFUNNEL] EUM agent url is empty');
        return;
    }

    const eumScript = document.createElement('script');
    eumScript.src = EUM_AGENT_URL;
    eumScript.defer = true;

    eumScript.onload = async () => {
        if (!window.STC_EUM) return;

        try {
            await window.STC_EUM.initialize({
                serverURL: NF_SERVER_URL + '/eum_data',
                settingURL: NF_SETTING_URL,
                clientId: CLIENT_ID,
                trackResource: true,
                printLog: false
            });
        } catch (e) {
            console.warn('[NetFUNNEL][EUM] init failed', e);
        }
    };

    document.head.appendChild(eumScript);
}
